import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface Reconstruction {
    isReconstruction: boolean;
    newSerialNumber?: string;
    oldSerialNumber?: string;
}

@Injectable({
    providedIn: 'root',
})
export class ProductReconstructionService {
    public constructor(private http: HttpClient) {}

    public getReconstructionStatus(serialnumber: string): Observable<Reconstruction> {
        return this.http.get<Reconstruction>(`/os/api/products/v1/${serialnumber}/reconstruction`);
    }
}
